import { Link } from "react-router-dom";

/**
 * MyLiveFriend brand logo.
 *
 * Props:
 *   - size:   "xs" | "sm" | "md" | "lg" | "xl"  (default "md")
 *   - variant:"full" | "mark"                   (default "full")
 *                 full = icon + wordmark, mark = icon only
 *   - to:     link target (default "/"). Pass null to render a non-link.
 *   - onDark: tweak wordmark color for dark backgrounds
 *   - className: extra classes
 *   - testid: data-testid override
 */
const SIZES = {
  xs: { h: "h-6", gap: "gap-1.5", text: "text-sm" },
  sm: { h: "h-8", gap: "gap-2", text: "text-base" },
  md: { h: "h-10", gap: "gap-2", text: "text-xl" },
  lg: { h: "h-14", gap: "gap-3", text: "text-2xl" },
  xl: { h: "h-20", gap: "gap-3", text: "text-3xl" },
};

export default function Logo({
  size = "md",
  variant = "full",
  to = "/",
  onDark = false,
  className = "",
  testid = "brand-logo",
}) {
  const s = SIZES[size] || SIZES.md;
  const content = (
    <span className={`inline-flex items-center ${s.gap} ${className}`} data-testid={testid}>
      <img
        src="/brand/mylivefriend-logo.png"
        alt="MyLiveFriend"
        className={`${s.h} w-auto select-none drop-shadow-sm`}
        draggable="false"
      />
      {variant === "full" && (
        <span className="sr-only">MyLiveFriend</span>
      )}
    </span>
  );
  if (!to) return content;
  return (
    <Link to={to} aria-label="MyLiveFriend home" className="inline-flex items-center shrink-0">
      {content}
    </Link>
  );
}

export function BrandFooter({ className = "" }) {
  return (
    <div className={`flex flex-col items-start gap-2 ${className}`}>
      <Logo size="md" to={null} />
      <div className="text-xs font-semibold text-slate-600 tracking-wide">
        Find <span className="text-teal-600">•</span> Date <span className="text-rose-500">•</span> Rent <span className="text-amber-500">•</span> Friends
      </div>
    </div>
  );
}
